import { ReactNode } from 'react';
import { Badge } from '@tinct/web-components';
import { PageStatus } from '@tinct/core-api-models';
import { PAGE_STATUS_CONFIG } from './page-status-config';

type PageStatusBadgeProps = {
  status: PageStatus | null;
  /** Optional label override (e.g. "5 ready" for summary counts). Defaults to PAGE_STATUS_CONFIG[status].label. */
  label?: ReactNode;
  className?: string;
};

export function PageStatusBadge({
  status,
  label,
  className,
}: PageStatusBadgeProps) {
  if (!status) return <span className="text-muted-foreground">-</span>;
  const config = PAGE_STATUS_CONFIG[status];
  return (
    <Badge variant="secondary" className={`gap-1.5 ${className ?? ''}`.trim()}>
      {!config.hideDot && (
        <span className={`size-2 rounded-full ${config.dotColor}`} />
      )}
      {label ?? config.label}
    </Badge>
  );
}
